var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-banner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"logo-banner__inner"},[_c('img',{staticClass:"logo-banner__logo",attrs:{"src":require(`@/assets/logos/banner.svg`),"alt":"Your CG products logo"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }